export const checkBrowserCookiesAllowed = () => {
  try {
    // Create cookie
    document.cookie = '@llStudents:cookietest=1';
    const ret = document.cookie.indexOf('@llStudents:cookietest=') !== -1;
    // Delete cookie
    document.cookie =
      '@llStudents:cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
    return ret;
  } catch (e) {
    return false;
  }
};

class AppMemoryCookies {
  constructor() {
    this.sessionCookie = '';
  }

  getSession() {
    return this.sessionCookie;
  }

  setSession(cookie) {
    this.sessionCookie = cookie;
  }

  removeSession() {
    this.sessionCookie = '';
  }
}

export default new AppMemoryCookies();
